import { Input } from 'app/components/ui/input';
import { Label } from 'app/components/ui/label';
import React from 'react';
import { useFormContext } from 'react-hook-form';

function Pricing() {
  const {
    register,
    formState: { errors },
  } = useFormContext();
  return (
    <>
      {/* Pricing */}
      <div className="bg-white  dark:bg-transparent rounded-lg p-4 mb-6">
        <Label>Pricing</Label>
        <div className="py-2 flex gap-4">
          <div className="flex-1">
            <Label htmlFor="original-price">Original Price </Label>
            <Input
              id="original-price"
              type="text"
              placeholder="Enter Original Price"
              {...register('original_price', {
                required: 'Original Price  is required',
              })}
            />
            {errors?.original_price && (
              <p className="text-red-500 text-sm mt-1">
                {typeof errors?.original_price?.message === 'string' && (
                  <p className="text-red-500 text-sm mt-1">
                    {errors.original_price.message}
                  </p>
                )}
              </p>
            )}
          </div>
          <div className="flex-1">
            <Label htmlFor="sale-price">Sale Price</Label>
            <Input
              id="sale-price"
              type="text"
              placeholder="Enter Sale Price"
              {...register('sale_price', {
                required: 'Sale Price is required',
              })}
            />
            {typeof errors?.sale_price?.message === 'string' && (
              <p className="text-red-500 text-sm mt-1">
                {errors.sale_price.message}
              </p>
            )}
          </div>
        </div>
      </div>
    </>
  );
}

export default Pricing;
